const SuccessStoriesSection = () => {
  const testimonials = [
    {
      name: 'Maria Rodriguez',
      location: 'East El Paso',
      story: 'After my husband passed away, I inherited a house that needed extensive repairs. I didn\'t have the money or energy to fix it up. These local buyers made me a fair offer and closed in just 10 days. They were compassionate, professional, and made a difficult time so much easier.',
      image: 'https://public.readdy.ai/ai/img_res/8d069d50f63315444d4aa07028fe39f2.jpg'
    },
    {
      name: 'James Mitchell',
      location: 'Northeast El Paso',
      story: 'I received PCS orders and had to relocate from Fort Bliss in 30 days. Traditional selling wasn\'t an option. They viewed my house, made an offer the next day, and we closed before my move date. As a military family, we really appreciated their understanding of our situation.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20African%20American%20man%20in%20his%2030s%2C%20military%20veteran%2C%20friendly%20smile%2C%20confident%20demeanor%2C%20El%20Paso%20Texas%2C%20natural%20lighting%2C%20professional%20appearance%2C%20southwestern%20setting&width=400&height=400&seq=elpasotesti002&orientation=squarish'
    },
    {
      name: 'Sandra and Tom Chen',
      location: 'West El Paso',
      story: 'Our rental property had problem tenants and needed major repairs. We were losing money every month. Selling to these buyers was the best decision we made. No repairs, no dealing with tenants, and we closed in two weeks. They handled everything professionally.',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Asian%20couple%20in%20their%2040s%2C%20happy%20together%2C%20warm%20smiles%2C%20El%20Paso%20Texas%20residents%2C%20natural%20outdoor%20lighting%2C%20trustworthy%20and%20friendly%20appearance%2C%20southwestern%20landscape&width=400&height=400&seq=elpasotesti003&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            <strong>Real Stories</strong> from El Paso Homeowners
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hear from your neighbors who have successfully sold their homes to us
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-20 h-20 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="text-xl font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-teal-600">{testimonial.location}</p>
                </div>
              </div>
              <div className="mb-4">
                <i className="ri-double-quotes-l text-4xl text-teal-200"></i>
              </div>
              <p className="text-gray-700 leading-relaxed italic">
                {testimonial.story}
              </p>
              <div className="mt-4 flex text-yellow-400">
                <i className="ri-star-fill text-xl"></i>
                <i className="ri-star-fill text-xl"></i>
                <i className="ri-star-fill text-xl"></i>
                <i className="ri-star-fill text-xl"></i>
                <i className="ri-star-fill text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-8 text-gray-900 text-center">
            Common Situations We Help With
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold mb-2 text-gray-900">Need to Sell Fast</h4>
              <p className="text-sm text-gray-600">Job relocation, financial hardship, or life changes requiring quick sale</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold mb-2 text-gray-900">Property Needs Repairs</h4>
              <p className="text-sm text-gray-600">Major repairs needed but no funds or desire to fix before selling</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-parent-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold mb-2 text-gray-900">Inherited Property</h4>
              <p className="text-sm text-gray-600">Dealing with estate settlement and don't want to manage the property</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-gear-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold mb-2 text-gray-900">Tired Landlord</h4>
              <p className="text-sm text-gray-600">Done managing tenants and want out of the rental property business</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
